import Vue from "vue"

import Vodal from 'vodal';
Vue.component(Vodal.name, Vodal);